export function getCategoryItems({ categories = [], items = [] }) {
  return categories.map(({ name, items: categoryItems }) => ({
    name,
    items: items.filter(({ _id: itemId }) => categoryItems.includes(itemId))
  }))
}

export function getCategoryNameFromItems(itemId, category) {
    const categories = category.filter(item => item.items.includes(itemId));
    if (categories && categories.length) {
        return categories[0].name
    }
    
}
